import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { Box, Typography } from "@mui/material";
import { ReactComponent as OwTextIcon } from "assets/img/ow-text-icon.svg";
import {
  MyHrLoginTwoFactorRegisterCancel,
  MyHrLoginTwoFactorVerifyEmailCode,
} from "my-hr/components";
import { MY_HR_REGISTER_2FA_EMAIL } from "my-hr/graphql";
import { useOcCurrentUserState } from "oc/hooks";

type MyHrLoginTwoFactorRegisterEmailProps = {
  onCancel: () => void;
  onForward: () => void;
  isMobile: boolean;
};

export const MyHrLoginTwoFactorRegisterEmail = ({
  onCancel,
  onForward,
  isMobile,
}: MyHrLoginTwoFactorRegisterEmailProps) => {
  const { t } = useTranslation();

  const { emailAddress } = useOcCurrentUserState();

  const [register2faEmail] = useMutation(MY_HR_REGISTER_2FA_EMAIL, {
    onCompleted: () => { },
    onError: (error) => {
      console.log({ error });
    },
  });

  useEffect(() => {
    register2faEmail({
      variables: {
        email: emailAddress,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        width: isMobile ? "auto" : "304px",
        padding: isMobile ? "0px 24px" : "unset",
      }}
    >
      <OwTextIcon />
      <Typography
        variant="h6"
        sx={{
          marginTop: "24px",
        }}
      >
        {t("MY_HR_2FA_AUTHENTICATION")}
      </Typography>
      <Box
        sx={{ textAlign: "center", marginTop: "24px", marginBottom: "16px" }}
      >
        <Typography variant="body1">{t("MY_HR_EMAIL_CODE_REQUEST")}</Typography>
      </Box>
      <MyHrLoginTwoFactorVerifyEmailCode
        onForward={onForward}
        isRegister={true}
        userData={{ email: emailAddress }}
        onCancel={onCancel}
      />
      <MyHrLoginTwoFactorRegisterCancel
        onCancel={onCancel}
        emailAddress={emailAddress}
      />
    </Box>
  );
};

export default MyHrLoginTwoFactorRegisterEmail;
